import { WORKOUT_SECTION_KEY } from '../../../model'
import saveReduxAction from '../../../../redux/actions/save'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import WORKOUT_SECTIONS_ACTION from '../../constants/action'
import { WORKOUT_SECTION_ENDPOINT } from '../../constants/endpoint'
import getByIdWorkoutSectionSelector from '../../selectors/get-by-id'
import getCurrentIdWorkoutSectionSelect from '../../selectors/get-current-id'
import canEditByIdWorkoutSelector from '../../../../workout/redux/selectors/can-edit-by-id'
import getByIdWorkoutSelector from '../../../../workout/redux/selectors/get-by-id'
import getCurrentOrStartedWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started'
import { logUtil } from 'packages/src'
import { interpolateStringUtil } from '../../../../../utils/string/interpolate'

function saveWorkoutSectionAction (idParam) {
  return (dispatch, getState) => {
    const id = idParam || getCurrentIdWorkoutSectionSelect(getState())
    const workoutSection = getByIdWorkoutSectionSelector(id)(getState())
    if (!workoutSection) {
      return
    }

    const workout = getByIdWorkoutSelector(getValueReduxUtil(workoutSection,
      WORKOUT_SECTION_KEY.WORKOUT_ID
    ))(getState()) ||
      (
        getCurrentOrStartedWorkoutSelect(getState())
      )

    if (workout && isNewReduxUtil(workout)) {
      logUtil('').debug('[noop] new workout: ', getIdReduxUtil(workout))
      return
    }

    if (!canEditByIdWorkoutSelector(getIdReduxUtil(workout))(getState())) {
      logUtil('').debug('[noop] can’t edit workout: ', getIdReduxUtil(workout))
      return
    }

    let endpoint
    if (isNewReduxUtil(workoutSection)) {
      endpoint = WORKOUT_SECTION_ENDPOINT.ROOT
    } else {
      endpoint = interpolateStringUtil(WORKOUT_SECTION_ENDPOINT.BY_ID, {
        id: getIdReduxUtil(workoutSection)
      })
    }

    return dispatch(saveReduxAction({
      type: WORKOUT_SECTIONS_ACTION.SAVE,
      payload: {
        endpoint,
        path: getPathReduxUtil(workoutSection)
      }
    }))
  }
}

export { saveWorkoutSectionAction }
